module.exports = __webpack_public_path__ + "static/img/bg1.3ea4312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/基因检测/bg1.png
// module id = X2b+
// module chunks = 1